import React from 'react';
import {useFormik} from "formik";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@material-ui/core";

const AddNormativeArticleDialog = (props) => {
    const {open, onClose, submitCallback} = props

    const onSubmit = async (values) => {
        await submitCallback(values)
    }

    const {getFieldProps, resetForm, submitForm} = useFormik({
        initialValues: {
            number: '',
            full_text: '',
            short_text: '',
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Добавить пункт</DialogTitle>
            <DialogContent>
                <TextField label={'Номер пункта'} fullWidth name={'number'} {...getFieldProps('number')}/>
                <TextField label={'Полный текст пункта'} fullWidth multiline name={'full_text'} {...getFieldProps('full_text')}/>
                <TextField label={'Сокращенный текст пункта'} fullWidth multiline name={'short_text'} {...getFieldProps('short_text')}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddNormativeArticleDialog;